import React from 'react';
import './results.css';

const Results: React.FC = () => {
  return (
    <div className="results-page">
      <section className="results-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-badge">🏆 Road leads to Excellence since 2010</div>
            <h1 className="hero-title">S-CUBUS Wall of Fame</h1>
            <p className="hero-subtitle">
              Celebrating the relentless hard work, dedication, and phenomenal 
              success of our students in JEE, NEET, and Olympiads.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Results;